import { render, staticRenderFns } from "./SettingPlanAddPad.vue?vue&type=template&id=bfc09db6&scoped=true&"
import script from "./SettingPlanAddPad.vue?vue&type=script&lang=js&"
export * from "./SettingPlanAddPad.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlanAddPad.vue?vue&type=style&index=0&id=bfc09db6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc09db6",
  null
  
)

export default component.exports